module.exports = __webpack_public_path__ + "static/img/アセット 47@3x.5d9496b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 47@3x.png
// module id = rRCF
// module chunks = 1